/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API - V2 Redesigned
 * Redesigned API endpoints (v2) for better performance with smaller, functional DTOs. Each endpoint provides only the data needed for specific UI components/tabs.  V2 endpoints are designed to replace heavy monolithic v1 endpoints: - Reduced response sizes by 80-95% - Component-specific data loading - Pagination and filtering support - Optimized for mobile and slow connections 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentStatus } from './TournamentStatus';
import {
    TournamentStatusFromJSON,
    TournamentStatusFromJSONTyped,
    TournamentStatusToJSON,
    TournamentStatusToJSONTyped,
} from './TournamentStatus';

/**
 * Minimal tournament info in user context
 * @export
 * @interface UserTournamentReference
 */
export interface UserTournamentReference {
    /**
     * 
     * @type {string}
     * @memberof UserTournamentReference
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentReference
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentReference
     */
    location?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserTournamentReference
     */
    date?: Date;
    /**
     * 
     * @type {TournamentStatus}
     * @memberof UserTournamentReference
     */
    status?: TournamentStatus;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentReference
     */
    teamsCount?: number;
    /**
     * User's role in this tournament
     * @type {string}
     * @memberof UserTournamentReference
     */
    role?: UserTournamentReferenceRole;
}

/**
* @export
* @enum {string}
*/
export enum UserTournamentReferenceRole {
    Creator = 'creator',
    Admin = 'admin'
}


/**
 * Check if a given object implements the UserTournamentReference interface.
 */
export function instanceOfUserTournamentReference(value: object): value is UserTournamentReference {
    return true;
}

export function UserTournamentReferenceFromJSON(json: any): UserTournamentReference {
    return UserTournamentReferenceFromJSONTyped(json, false);
}

export function UserTournamentReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTournamentReference {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'location': json['location'] == null ? undefined : json['location'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'status': json['status'] == null ? undefined : TournamentStatusFromJSON(json['status']),
        'teamsCount': json['teams_count'] == null ? undefined : json['teams_count'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function UserTournamentReferenceToJSON(json: any): UserTournamentReference {
    return UserTournamentReferenceToJSONTyped(json, false);
}

export function UserTournamentReferenceToJSONTyped(value?: UserTournamentReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'location': value['location'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'status': TournamentStatusToJSON(value['status']),
        'teams_count': value['teamsCount'],
        'role': value['role'],
    };
}

